<script>
import BaseView from "@/views/BaseView.vue";
import CustomerEditForm from "./EditForm.vue";

export default {
  name: "CustomerEdit",
  components: { CustomerEditForm },
  mixins: [BaseView],
  data() {
    return {
      perm: "carriers",
      item: null,
      loading: false,
    };
  },
  computed: {
    isNew() {
      return this.$route.params.id === "new";
    },
  },
  async created() {
    this.setTitle(this.$t("company.customer"));
    await this.loadCustomer();
  },
  methods: {
    async loadCustomer() {
      if (this.isNew) {
        return;
      }

      this.loading = true;
      try {
        const resp = await this.$api.company.findCustomerById(this.$route.params.id);
        this.item = resp.data;
      } catch (e) {
        console.error("Error load customer by id: ", e);
      }

      this.loading = false;
    },
  },
};
</script>

<template>
  <customer-edit-form v-if="isNew || !loading" :customer="item" @close="$router.push({ name: 'customers' })" />
</template>
